import { render } from "./CategoryModal.vue?vue&type=template&id=39d71246&scoped=true"
import script from "./CategoryModal.vue?vue&type=script&lang=js"
export * from "./CategoryModal.vue?vue&type=script&lang=js"

import "./CategoryModal.vue?vue&type=style&index=0&id=39d71246&scoped=true&lang=css"

import exportComponent from "/Users/q/Documents/projects/religious-app/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39d71246"]])

export default __exports__